// extracted by mini-css-extract-plugin
module.exports = {"cardList":"OrgCanUseCardInfo_cardList__1S71z","card":"OrgCanUseCardInfo_card__1Ye0v","read":"OrgCanUseCardInfo_read__3212L"};